import { Vue, Component } from "vue-property-decorator";

import { getTranslatedImage as getTranslatedImageHelper } from "./ModuleHelpers";

@Component
export class ModuleHelperMixin extends Vue {
  public getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }
}
